import lodash from 'lodash';
import React from 'react';
import { ComplianceModuleFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import useTopicComplianceModuleMap, { useAdvancedAnalysisItemComplianceModuleMap, useComplianceOperationItemComplianceModuleMap } from './useTopicComplianceModuleMap';

export type ModuleItems<T> = {
  module: ComplianceModuleFieldsFragment | undefined;
  items: T[];
};

// eslint-disable-next-line no-unused-vars
export default function useModuleItems<T>(complianceModules: ComplianceModuleFieldsFragment[], items: T[], getItemId: (item: T) => string): ModuleItems<T>[] {
  const topicModuleMap = useTopicComplianceModuleMap(complianceModules);
  const advancedAnalysisItemModuleMap = useAdvancedAnalysisItemComplianceModuleMap(complianceModules);
  const complianceOperationItemModuleMap = useComplianceOperationItemComplianceModuleMap(complianceModules);
  const mergedMap = new Map<string, ComplianceModuleFieldsFragment>([...topicModuleMap, ...advancedAnalysisItemModuleMap, ...complianceOperationItemModuleMap]);
  const groupedByModule = React.useMemo(() => {
    const itemsWithModule = items.map((item) => ({
      item,
      module: mergedMap.get(getItemId(item)),
    }));

    const groupedItems = lodash.groupBy(itemsWithModule, (item) => item.module?.id);

    const modulesWithItems = Object.values(groupedItems).map((ha) => ({
      module: ha[0].module,
      items: ha.map((i) => i.item),
    }));

    return modulesWithItems.sort((modA, modB) => {
      if (!modB.module) return -1;
      if (!modA.module) return 1;
      return modA.module.name.localeCompare(modB.module.name);
    });
  }, [items, topicModuleMap, advancedAnalysisItemModuleMap, complianceOperationItemModuleMap]);

  return groupedByModule;
}
